import history from 'lib/history';
import { call, fork, put, select } from 'redux-saga/effects';
import { getClient, getClientCode } from 'actions/ui/init/initSelectors';
import { UPDATE_USER } from 'actions/auth/login';
import { clearComposePage } from 'actions/communication/compose/composeActions';
import { fetchUsersWorker as fetchAccountsWorker } from 'actions/accounts/users/usersActions';
import { fetchAllGroupsWorker } from 'actions/accounts/groups/groupsActions';
import { fetchUsersWorker } from 'actions/communication/messages/sagas';
import { getBrowserPathname } from 'actions/routes/routeSelectors';
import { getLangCodes } from 'actions/auth/login';
import { getLocale } from 'actions/language/selectors';
import { initializeAsyncAlertWorker } from 'actions/travelSecurity/alerts/actions';
import { initializeAsyncClientWorker } from 'actions/ui/init/initSagas';
import { initializeAsyncMapWorker } from 'actions/travelSecurity/map/mapSagas';
import { push } from 'react-router-redux';
import { reloadPlatformUsageData } from 'actions/platformUsageAnalytics/platformUsageAnalytics';
import { reloadSHAWAnalyticsData } from 'actions/SHAWAnalytics/actions';
import { reloadCallCenterData } from 'actions/callCenterUtilization/actions';
import { router } from 'redux-saga-router';
import { setAuthTokenWorker } from 'actions/auth/sso';
import { setClientCode } from 'actions/ui/init/initActions';
import { setLanguage } from 'redux-i18n';

export function* routeSaga() {
  yield fork(
    router,
    history,
    {
      '/:lang/NotFound': function*({ lang }) {
        const languages = yield select(getLangCodes);
        if (!languages.includes(lang)) {
          yield put(push(`/${languages[0]}/NotFound`));
        }
        yield put(setLanguage(lang));
      },
      '/:lang/:client/*': function*({ lang, client }) {
        const currentLang = yield select(getLocale);
        const currentClientCode = yield select(getClientCode);
        const currentClient = yield select(getClient);

        // Keep the user info up to date.
        yield put({ type: UPDATE_USER });

        if (
          //if either client code or language has changed or client has not been loaded yet
          currentClient.name == '' ||
          currentClientCode != client ||
          currentLang != lang
        ) {
          const languages = yield select(getLangCodes);
          const path = yield select(getBrowserPathname);

          if (!languages.includes(lang))
            //if the selected language is not in the list of supported languages default to first index (eng)
            yield put(push(`/${languages[0]}/${client}/${path}`));

          if (lang != currentLang) {
            yield put(setLanguage(lang));
          }

          yield put(setClientCode(client));
          yield call(initializeAsyncClientWorker);
        }
      },
      '/:lang/:client/NotFound': function*({ lang }) {
        yield put(push(`/${lang}/NotFound`));
      },
      '/:lang/:client/platform-usage': reloadPlatformUsageData,
      '/:lang/:client/data-reports': reloadCallCenterData,
      '/:lang/:client/shaw-statistics': reloadSHAWAnalyticsData,
      '/:lang/:client/accounts/users': fetchAccountsWorker,
      '/:lang/:client/accounts/groups': fetchAllGroupsWorker,
      '/:lang/:client/communication/messages*': clearComposePage,
      '/:lang/:client/communication/messages': fetchUsersWorker,
      '/:lang/:client/travel-security/alerts': initializeAsyncAlertWorker,
      '/:lang/:client/travel-security/map': initializeAsyncMapWorker,
      // NOTE: if the app ever gets any routes more than 2 levels deep,
      // you need to add more params to this route and the matching saga
      '/:lang/:client/sso/token/:token/:redirect/:redirect2?': setAuthTokenWorker
    },
    {
      matchAll: true
    }
  );
}



// WEBPACK FOOTER //
// ./src/actions/routes/routeSagas.js